
<template>
   <div class="select-product">
        <div v-if="modalType === 'edit'" class="dname">
          {{name}}
        </div>
        <template v-if="modalType === 'new' || updateStatus === true">
          <scope-product @product="onChange"/>
        </template>
        <el-button style="margin-left: 6px;" v-if="modalType !== 'new'" type="primary" @click="updateStatus = !updateStatus">{{ updateStatus ? $t('pages_birthday_discount_index_209'): $t('pages_deduct_coupon_rule_components_scopeofuse_index_449') }}</el-button>
   </div>
</template>

<script>
import i18n from '../../../../locales/index'

import ScopeProduct from './product'

export default {
  name: 'SelectProduct',
  model: {
    prop: 'fresh_product_id',
    event: 'change'
  },
  components: {
    ScopeProduct
  },
  props: {
    fresh_product_id: Number,
    modalType: String,
    name: String
  },
  data () {
    return {
      updateStatus: false,
    }
  },
  methods: {
    onChange (data) {
      this.$emit('change', data.value)
      this.$emit('changeName', data.name)
    }
  }
}
</script>

<style lang='scss' scoped>
.select-product{
  display: flex;
  .dname{
    margin-right: 6px;
  }
}
</style>
